module.exports = __webpack_public_path__ + "static/media/excelClassGuide.adb39873.webp";